import qs from 'querystring';

import _debounce from 'lodash/debounce';
import Router from 'next/router';
import { compile } from 'path-to-regexp';

import { REDUX_STORE } from '../constants/common';
import { SEARCH, SPECIAL_PROJECTS } from '../constants/routes';
import { getWhitelabel } from '../reducers/whitelabel';

import { isServer } from './isServer';

interface ILinkParams {
  queryParams?: Record<string, any>;

  [name: string]: any;
}

export const toString = (params: Record<string, any>, prefix = '?') => {
  const queryString = qs.stringify(params);

  return queryString ? prefix + queryString : '';
};

export const splitProperties = (isLeft, obj) => {
  return Object.entries(obj).reduce(
    ([left, right], [k, v]) => (isLeft(v, k) ? [{ ...left, [k]: v }, right] : [left, { ...right, [k]: v }]),
    [{}, {}],
  );
};

export const addInitialSlash = (str) => (str.match(/^\//) ? str : `/${str}`);

export const replaceWithParams = (pattern, params) => {
  const toPathRegexp = compile(pattern);

  return toPathRegexp(params);
};

export const createLinkProps = (page: string = '', pattern: string = '', params: ILinkParams = {}) => {
  if (!isServer) {
    const isWL = getWhitelabel(window[REDUX_STORE].getState());
    if (isWL && !params.queryParams?.wl)
      params.queryParams = {
        ...params.queryParams,
        wl: isWL,
      };
  }

  const [
    inlineParams,
    {
      // @ts-ignore
      queryParams = {},
      ...restParams
    },
  ] = splitProperties((_, key) => pattern.match(`:${key}`), params);

  return {
    ...restParams,
    href: `${addInitialSlash(page)}${toString({ ...queryParams, ...inlineParams })}`,
    as: `${replaceWithParams(pattern, inlineParams)}/${toString(queryParams)}`,
  };
};

export const updateQueryFilters = _debounce((filters, query, page: 'search' | 'specialProjects') => {
  const queryParams = {
    ...query,
    ...filters,
  };

  const { href, as } = createLinkProps(`/${page}`, page === 'search' ? SEARCH : SPECIAL_PROJECTS, { queryParams });

  Router.replace(href, as, { shallow: page !== 'search' });
}, 500);

export const replaceQuery = (url: string) => url.split('?')[0];
